<h3 mat-dialog-title>Ajouter une ressource</h3>
<mat-dialog-content class="caaks-dialog-text">
  <div>Renseigner les informations suivantes.</div>
  <div>
    @if (!loading) {
      <form [formGroup]="userForm" novalidate>
        <div>
          <mat-form-field>
            <input type="text" placeholder="Tapez le nom de la ressource" aria-label="Number" matInput
              formControlName="resources" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of  filteredResourcesByName|async; track option) {
                <mat-option [value]="option.name">
                  {{option.name}}
                </mat-option>
              }
            </mat-autocomplete>
            @if (resources!.hasError('uniqueName')) {
              <mat-error>
                Une ressource existe déjà avec ce nom.
              </mat-error>
            }
            @if (resources!.hasError('required')) {
              <mat-error> Le nom est requis. </mat-error>
            }
          </mat-form-field>
          <mat-checkbox formControlName="usePattern">Utiliser un filtre (ex: DEV-*)</mat-checkbox>
          @if (usePattern?.value) {
            <mat-form-field>
              <input matInput formControlName="resources" placeholder="Tapez le filtre" />
              @if (resources!.hasError('uniqueName')) {
                <mat-error>
                  Une ressource existe déjà avec ce nom.
                </mat-error>
              }
              @if (resources!.hasError('required')) {
                <mat-error> Le nom est requis. </mat-error>
              }
            </mat-form-field>
          }
        </div>
      </form>
    } @else {
      <div style="display: flex;
      padding: 0px 5% 5% 0px;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: center;">
        <mat-spinner [diameter]="40"></mat-spinner> <span style="margin-left: 10px;">Chargement des
      données...</span>
    </div>
  }
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container>
    <button mat-button type="submit" color="primary" [disabled]="isCreateDisabled()" (click)="add()">Ajouter</button>
    <button mat-button (click)="cancel()">Annuler</button>
  </ng-container>
</mat-dialog-actions>